/* eslint-disable jsx-a11y/no-static-element-interactions, jsx-a11y/no-noninteractive-element-interactions */
import React, { useContext, useEffect } from 'react';
import classNames from 'classnames';
import ProductListingPageContext from 'data-hooks/context/ProductListingPageContext';
import { useAtom } from 'jotai';

import productsCountAtom from '../atoms/productsCountAtom';

const ProductSearchCount = ({ title, indexClick, selectedOption, id }) => {
  const { totalProductCount } = useContext(ProductListingPageContext) ?? {};

  const [productsCount, setProductsCount] = useAtom(productsCountAtom);

  useEffect(() => {
    if (totalProductCount) {
      setProductsCount(totalProductCount);
    }
  }, [totalProductCount, setProductsCount]);

  const count = totalProductCount || productsCount;

  const isSelected = selectedOption === id;

  return (
    <div className="px-0 py-1.5 max-[767px]:p-0 hover:text-brand">
      <button
        type="button"
        className={classNames('w-full bg-white text-center lg:text-left', {
          'font-bold': isSelected,
        })}
        onClick={() => {
          indexClick(title.toLowerCase());
        }}
      >
        {/* only show the count when its greater than zero */}
        {`${title} ${count ? `(${count})` : ''}`}
      </button>
    </div>
  );
};

export default ProductSearchCount;
